import { TabContext, TabList, TabPanel } from "@mui/lab"
import { Box, styled, SxProps, Tab, Theme } from "@mui/material"
import { useStyles } from "./styles"
import { CustomeTabProps } from "./types"

export const CustomeTab = ({ listTab, children, value, endChildren, startChildren, listTabContainerProps, tabList, justifyContent, endChildrenTab, }: CustomeTabProps) => {
    const styles = useStyles()
    return (
        <TabContext value={value}>
            <Box {...listTabContainerProps} sx={{ ...styles.tabContainer, ...listTabContainerProps?.sx } as SxProps<Theme>}>
                {startChildren}

                <TabList {...tabList} sx={ {...styles.tabList({ justifyContent }), ...tabList?.sx } as SxProps<Theme>}>
                    {
                        listTab.map(item => <Tab key={item.id} value={item.value} label={item.label.toUpperCase()} />)
                    }

                    {endChildren}
                </TabList>
                {endChildrenTab}
            </Box>

            {children}
        </TabContext>
    )
}

export const CustomePanel = styled(TabPanel)(() => ({
    marginLeft: '3px',
    boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)'
}))